import { Box, Spinner, Text } from "@primer/react";

interface ILoadingSpinnerProps {
    message?: string;
    size?: "small" | "medium" | "large";
    /** Full-page centering. Default false (chỉ centered trong parent). */
    fullPage?: boolean;
    py?: number;
}

/**
 * Centered spinner — dùng cho loading inline trong page.
 * `fullPage` để center trong toàn viewport (vd lúc khởi động app).
 */
const LoadingSpinner = ({ message, size = "medium", fullPage = false, py = 5 }: ILoadingSpinnerProps) => {
    const containerSx = fullPage
        ? {
              minHeight: "calc(100vh - 60px)",
              display: "flex",
              flexDirection: "column" as const,
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
          }
        : {
              display: "flex",
              flexDirection: "column" as const,
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              py,
          };

    return (
        <Box sx={containerSx}>
            <Spinner size={size} />
            {message && (
                <Text sx={{ color: "fg.muted", fontSize: 1 }}>{message}</Text>
            )}
        </Box>
    );
};

export default LoadingSpinner;
